webpackJsonp([0],{

/***/ "+GdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-article"},[_c('h2',[_vm._v("Politique de confidentialité - RGPD")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('legal',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{domProps:{"innerHTML":_vm._s(props.content)}})]}}])}),_vm._v(" "),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1KxI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlePreview_vue__ = __webpack_require__("7CVQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36de3c2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlePreview_vue__ = __webpack_require__("7XYc");
function injectStyle (ssrContext) {
  __webpack_require__("Ewai")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36de3c2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36de3c2c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4FHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PressReleasePage_vue__ = __webpack_require__("lWFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80cf49fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PressReleasePage_vue__ = __webpack_require__("GD7O");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PressReleasePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80cf49fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PressReleasePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4fx3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlePage_vue__ = __webpack_require__("Hox2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54412ac5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlePage_vue__ = __webpack_require__("bZjV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54412ac5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5zy5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"primary"},[_c('div',{staticClass:"firstbar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-12"},[_c('div',{staticClass:"brand"},[_c('router-link',{attrs:{"to":{ name: 'LastArticles' }}},[_c('img',{attrs:{"src":"/static/images/logo.jpg"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-9 col-sm-12 text-right"},[_c('ad',{attrs:{"format":"header"}})],1)])])])]),_vm._v(" "),_c('section',{class:{ home: _vm.$route.name !== 'ArticlePage', single: ['ArticlePage', 'PressReleasePage'].indexOf(_vm.$route.name) !== -1 }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row router-view"},[_c('div',{staticClass:"col-md-8 col-sm-12 col-xs-12"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"banner"},[_c('ad',{attrs:{"format":"header"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-md-4 sidebar",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar-title for-tablet"},[_vm._v("Sidebar")]),_vm._v(" "),_c('aside',[_c('div',{staticClass:"aside-body"},[_c('br'),_c('br'),_vm._v(" "),_c('form',{staticClass:"search",attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();_vm.search($event)}}},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control",attrs:{"type":"text","name":"q","placeholder":"Recherche"},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_vm._m(0)])])])])]),_vm._v(" "),_c('aside',[_c('div',{staticClass:"aside-body"},[_c('form',{staticClass:"newsletter",on:{"submit":function($event){$event.preventDefault();_vm.subscribeUser($event)}}},[_vm._m(1),_vm._v(" "),_c('add-subscriber',{ref:"addSubscriber",attrs:{"broadcastChannel":"ITRInnovation"}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control email",attrs:{"type":"email","placeholder":"Adresse email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('p',[_vm._v("Veuillez renseigner votre email afin de vous abonner à la newsletter.")]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'RGPD' }}},[_vm._v("Voir la politique de confidentialité")])],1)],1)])]),_vm._v(" "),_c('aside',[_c('h1',{staticClass:"aside-title"},[_vm._v("Communiqués de presse")]),_vm._v(" "),_c('div',{staticClass:"aside-body"},[_c('press-releases',{attrs:{"limit":10,"withFile":false},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.pressReleases),function(pressRelease){return _c('div',[_c('article',{staticClass:"article-mini"},[_c('div',{staticClass:"inner"},[_c('div',[_c('h1',[(pressRelease.fileURL)?_c('a',{attrs:{"href":pressRelease.fileURL,"target":"_blank"}},[_vm._v(_vm._s(pressRelease.shortTitle))]):_c('router-link',{attrs:{"to":{ name: 'PressReleasePage', params: { id: pressRelease.id, slug: pressRelease.slug } }}},[_vm._v(_vm._s(pressRelease.shortTitle))])],1)])])])])})}}])})],1)]),_vm._v(" "),_c('aside',[_c('h1',{staticClass:"aside-title"},[_vm._v("ITRTV")]),_vm._v(" "),_c('div',{staticClass:"aside-body"},[_c('vimeo-videos',{attrs:{"per_page":1},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.videos),function(video){return _c('article',{staticClass:"article-mini"},[_c('div',{staticClass:"inner"},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(video.iframeCode)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',[_c('a',{attrs:{"href":video.link,"target":"_blank"}},[_vm._v(_vm._s(video.name))])])])])])})}}])})],1)]),_vm._v(" "),_c('aside',[_c('ad',{attrs:{"format":"card"}})],1)])])])]),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 col-xs-12"},[_c('div',{staticClass:"block"},[_c('h1',{staticClass:"block-title"},[_vm._v("Derniers articles")]),_vm._v(" "),_c('div',{staticClass:"block-body"},[_c('articles-query',{attrs:{"tags":['innov_oid'],"limit":4,"withPagination":false},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.articles),function(article){return _c('article',{staticClass:"article-mini"},[_c('div',{staticClass:"inner"},[(article.featured_img)?_c('figure',[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":article.featured_img}})])]):_vm._e(),_vm._v(" "),_c('div',{class:{ padding: article.featured_img }},[_c('h1',[_c('router-link',{attrs:{"to":{ name: 'ArticlePage', params: { id: article.oid, slug: article.slug } }}},[_vm._v(_vm._s(article.title))])],1)])])])})}}])})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-12 col-sm-6"},[_c('div',{staticClass:"block"},[_c('h1',{staticClass:"block-title"},[_vm._v("Partager")]),_vm._v(" "),_c('div',{staticClass:"block-body"},[_c('ul',{staticClass:"social trp"},[_c('li',[_c('a',{staticClass:"facebook",attrs:{"href":"https://www.facebook.com/sharer/sharer.php","target":"_blank"}},[_c('svg',[_c('rect',{attrs:{"width":"0","height":"0"}})]),_vm._v(" "),_c('i',{staticClass:"ion-social-facebook"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"twitter",attrs:{"href":("https://twitter.com/home?status=" + _vm.pageUrl),"target":"_blank"}},[_c('svg',[_c('rect',{attrs:{"width":"0","height":"0"}})]),_vm._v(" "),_c('i',{staticClass:"ion-social-twitter"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"googleplus",attrs:{"href":("https://plus.google.com/share?url=" + _vm.pageUrl),"target":"_blank"}},[_c('svg',[_c('rect',{attrs:{"width":"0","height":"0"}})]),_vm._v(" "),_c('i',{staticClass:"ion-social-googleplus"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"linkedin",attrs:{"href":("https://www.linkedin.com/shareArticle?mini=true&url=" + _vm.pageUrl),"target":"_blank"}},[_c('svg',[_c('rect',{attrs:{"width":"0","height":"0"}})]),_vm._v(" "),_c('i',{staticClass:"ion-social-linkedin"})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"rss",attrs:{"href":"http://rss.itrinnovation.com","target":"_blank"}},[_c('svg',[_c('rect',{attrs:{"width":"0","height":"0"}})]),_vm._v(" "),_c('i',{staticClass:"ion-social-rss"})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'RGPD' }}},[_vm._v("Voir la politique de confidentialité")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('site-footer'),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v("\n            COPYRIGHT © ITRInnovation 2017. Tous droits réservés.\n          ")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary"},[_c('i',{staticClass:"ion-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"ion-ios-email-outline"}),_vm._v(" "),_c('h1',[_vm._v("S'abonner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary"},[_c('i',{staticClass:"ion-paper-airplane"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"block"},[_c('h1',{staticClass:"block-title"},[_vm._v("Contact")]),_vm._v(" "),_c('div',{staticClass:"block-body"},[_c('p',{staticClass:"brand-description"},[_vm._v("\n                Groupe ITRnews"),_c('br'),_vm._v("\n                21 rue Henry Monnier"),_c('br'),_vm._v("\n                75009 Paris\n              ")]),_vm._v(" "),_c('p',{staticClass:"brand-description"},[_c('strong',[_vm._v("Pour nous contacter :")]),_c('br'),_vm._v("\n                Tél : 01 40 16 10 77\n              ")]),_vm._v(" "),_c('p',{staticClass:"brand-description"},[_c('strong',[_vm._v("Publicité")]),_c('br'),_vm._v("\n                Tél : 01 40 16 18 48"),_c('br'),_vm._v("\n                Fax : 01 49 95 00 23"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:publicite@itrmobiles.com","target":"_blank"}},[_vm._v("Contactez nous par mail")])]),_vm._v(" "),_c('p',{staticClass:"brand-description"},[_c('strong',[_vm._v("Rédaction")]),_c('br'),_vm._v("\n                Tél : 01 40 16 18 55"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:redaction@itrmobiles.com","target":"_blank"}},[_vm._v("Contactez nous par mail")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6zpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"last-articles"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('articles-query',{attrs:{"tags":['innov_oid']},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.articles),function(article){return _c('div',[_c('article-preview',{attrs:{"article":article}})],1)})}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_c('div',[_vm._v("Derniers articles")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7CVQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArticlePreview',
  props: {
    article: { type: Object, required: true }
  }
});

/***/ }),

/***/ "7XYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"col-md-12 article-list"},[_c('div',{staticClass:"inner"},[(_vm.article.featured_img)?_c('figure',[_c('router-link',{attrs:{"to":{ name: 'ArticlePage', params: { id: _vm.article.oid, slug: _vm.article.slug }}}},[_c('img',{attrs:{"src":_vm.article.featured_img}})])],1):_vm._e(),_vm._v(" "),_c('div',{class:{ details: true, 'no-margin-left': !_vm.article.featured_img }},[_c('div',{staticClass:"detail"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.article.date))])]),_vm._v(" "),_c('h1',[_c('router-link',{attrs:{"to":{ name: 'ArticlePage', params: { id: _vm.article.oid, slug: _vm.article.slug }}}},[_vm._v(_vm._s(_vm.article.title))])],1),_vm._v(" "),_c('p',[_vm._v("\n        "+_vm._s(_vm.article.short_description)+"\n      ")]),_vm._v(" "),_c('footer',[_c('router-link',{staticClass:"btn btn-primary more",attrs:{"to":{ name: 'ArticlePage', params: { id: _vm.article.oid, slug: _vm.article.slug }}}},[_c('div',[_vm._v("Lire plus")]),_vm._v(" "),_c('div',[_c('i',{staticClass:"ion-ios-arrow-thin-right"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8rlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_ArticlePreview__ = __webpack_require__("1KxI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LastArticles',
  components: { ArticlePreview: __WEBPACK_IMPORTED_MODULE_1__elements_ArticlePreview__["a" /* default */], ArticlesQuery: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["ArticlesQuery"] }
});

/***/ }),

/***/ "Ewai":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GD7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-article"},[_c('single-press-release',{attrs:{"pressReleaseId":_vm.$route.params.id},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.pressRelease)?_c('article',{staticClass:"article main-article"},[_c('header',[_c('h1',[_vm._v(_vm._s(props.pressRelease.titre))]),_vm._v(" "),_c('ul',{staticClass:"details"},[_c('li',[_vm._v(_vm._s(props.pressRelease.date))])])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{domProps:{"innerHTML":_vm._s(props.pressRelease.body_html)}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sharing"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"ion-android-share-alt"}),_vm._v(" Partage")]),_vm._v(" "),_c('ul',{staticClass:"social"},[_c('li',[_c('a',{staticClass:"facebook",attrs:{"href":"https://www.facebook.com/sharer/sharer.php","target":"_blank"}},[_c('i',{staticClass:"ion-social-facebook"}),_vm._v(" Facebook\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"twitter",attrs:{"href":("https://twitter.com/home?status=" + _vm.pageUrl),"target":"_blank"}},[_c('i',{staticClass:"ion-social-twitter"}),_vm._v(" Twitter\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"googleplus",attrs:{"href":("https://plus.google.com/share?url=" + _vm.pageUrl),"target":"_blank"}},[_c('i',{staticClass:"ion-social-googleplus"}),_vm._v(" Google+\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"linkedin",attrs:{"href":("https://www.linkedin.com/shareArticle?mini=true&url=" + _vm.pageUrl),"target":"_blank"}},[_c('i',{staticClass:"ion-social-linkedin"}),_vm._v(" Linkedin\n            ")])])])])]}}])}),_vm._v(" "),_c('h4',[_vm._v("Commentaires")]),_vm._v(" "),_c('comments',{attrs:{"id":("press-" + (_vm.$route.params.id))}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hox2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArticlePage',
  components: { SingleArticle: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["SingleArticle"], Comments: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["Comments"], MailTransfer: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["MailTransfer"] },
  mounted: function mounted() {
    this.pageUrl = window.location.href;
  },
  data: function data() {
    return {
      pageUrl: ''
    };
  }
});

/***/ }),

/***/ "I7tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articles-for-category"},[_c('div',{staticClass:"last-articles"},[_c('div',{staticClass:"line"},[_c('div',[_vm._v("Résultats pour '"+_vm._s(_vm.$route.params.query)+"'")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('articles-query',{attrs:{"tags":['innov_oid'],"query":_vm.$route.params.query},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.articles),function(article){return _c('div',[_c('article-preview',{attrs:{"article":article}})],1)})}}])})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c91d698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("5zy5");
function injectStyle (ssrContext) {
  __webpack_require__("eNYe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c91d698_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__("ju79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "RwQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RGPD',
  components: { Legal: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["Legal"] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LastArticles__ = __webpack_require__("nJhU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ArticlePage__ = __webpack_require__("4fx3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PressReleasePage__ = __webpack_require__("4FHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ArticlesSearch__ = __webpack_require__("aeg9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RGPD__ = __webpack_require__("okdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_NotFound__ = __webpack_require__("YcJa");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'LastArticles',
    component: __WEBPACK_IMPORTED_MODULE_2__components_LastArticles__["a" /* default */]
  }, {
    path: '/articles/:id/:slug',
    name: 'ArticlePage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ArticlePage__["a" /* default */]
  }, {
    path: '/communiques-de-press/:id/:slug',
    name: 'PressReleasePage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_PressReleasePage__["a" /* default */]
  }, {
    path: '/articles/:query?',
    name: 'ArticlesSearch',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ArticlesSearch__["a" /* default */]
  }, {
    path: '/rgpd',
    name: 'RGPD',
    component: __WEBPACK_IMPORTED_MODULE_6__components_RGPD__["a" /* default */]
  }, { path: '/erreur/404', component: __WEBPACK_IMPORTED_MODULE_7__components_NotFound__["a" /* default */] }, { path: '*', redirect: '/erreur/404' }]
});

router.afterEach(function () {
  $('.backdrop').click();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d7e302_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("q5GI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32d7e302_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aeg9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlesSearch_vue__ = __webpack_require__("gosK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229fd956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlesSearch_vue__ = __webpack_require__("I7tn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArticlesSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229fd956_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArticlesSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bZjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-article"},[_c('single-article',{attrs:{"articleId":_vm.$route.params.id},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.article)?_c('article',{staticClass:"article main-article"},[_c('header',[_c('h1',[_vm._v(_vm._s(props.article.title))]),_vm._v(" "),_c('ul',{staticClass:"details"},[_c('li',[_vm._v(_vm._s(props.article.date))])])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{domProps:{"innerHTML":_vm._s(props.article.body_html)}})]),_vm._v(" "),_c('div',{staticClass:"sharing"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"ion-android-share-alt"}),_vm._v(" Partage")]),_vm._v(" "),_c('ul',{staticClass:"social"},[_c('li',[_c('a',{staticClass:"facebook",attrs:{"href":"https://www.facebook.com/sharer/sharer.php","target":"_blank"}},[_c('i',{staticClass:"ion-social-facebook"}),_vm._v(" Facebook\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"twitter",attrs:{"href":("https://twitter.com/home?status=" + _vm.pageUrl),"target":"_blank"}},[_c('i',{staticClass:"ion-social-twitter"}),_vm._v(" Twitter\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"googleplus",attrs:{"href":("https://plus.google.com/share?url=" + _vm.pageUrl),"target":"_blank"}},[_c('i',{staticClass:"ion-social-googleplus"}),_vm._v(" Google+\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"linkedin",attrs:{"href":("https://www.linkedin.com/shareArticle?mini=true&url=" + _vm.pageUrl),"target":"_blank"}},[_c('i',{staticClass:"ion-social-linkedin"}),_vm._v(" Linkedin\n            ")])])])]),_vm._v(" "),_c('mail-transfer',{attrs:{"id":_vm.$route.params.id,"broadcastChannel":"ITRInnovation"}}),_vm._v(" "),_c('h4',[_vm._v("Sujets similaires")]),_vm._v(" "),_c('div',{staticClass:"similarArticles"},[_c('ul',_vm._l((props.article.similarArticles),function(similarArticle,index){return _c('li',[_c('a',{attrs:{"href":("https://" + (similarArticle.hostname) + "/articles/" + (similarArticle.oid) + "/" + (similarArticle.slug)),"target":"_blank"}},[_vm._v(_vm._s(similarArticle.title))]),_c('br')])}))])],1):_vm._e()]}}])}),_vm._v(" "),_c('h4',[_vm._v("Commentaires")]),_vm._v(" "),_c('comments',{attrs:{"id":_vm.$route.params.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eNYe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gosK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_ArticlePreview__ = __webpack_require__("1KxI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArticlesSearch',
  components: { ArticlesQuery: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["ArticlesQuery"], ArticlePreview: __WEBPACK_IMPORTED_MODULE_1__elements_ArticlePreview__["a" /* default */] }
});

/***/ }),

/***/ "lWFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PressReleasePage',
  components: { SinglePressRelease: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["SinglePressRelease"], Comments: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["Comments"] },
  mounted: function mounted() {
    this.pageUrl = window.location.href;
  },
  data: function data() {
    return {
      pageUrl: ''
    };
  }
});

/***/ }),

/***/ "nJhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastArticles_vue__ = __webpack_require__("8rlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a07fb03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastArticles_vue__ = __webpack_require__("6zpA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastArticles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a07fb03_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastArticles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "okdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RGPD_vue__ = __webpack_require__("RwQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec7ea84e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RGPD_vue__ = __webpack_require__("+GdD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RGPD_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec7ea84e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RGPD_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q5GI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Erreur 404 - Page non trouvée")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { Ad: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["Ad"], AddSubscriber: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["AddSubscriber"], SiteFooter: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["SiteFooter"], PressReleases: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["PressReleases"], VimeoVideos: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["VimeoVideos"], ArticlesQuery: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["ArticlesQuery"] },
  mixins: [__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["categories"]],
  methods: {
    subscribeUser: function subscribeUser(event) {
      event.preventDefault();
      this.$refs.addSubscriber.sendRequest(this.email);
    },
    search: function search(event) {
      event.preventDefault();
      this.$router.push({ name: 'ArticlesSearch', params: { query: this.query } });
    }
  },
  mounted: function mounted() {
    this.pageUrl = window.location.href;
  },
  data: function data() {
    return {
      email: '',
      pageUrl: '',
      query: ''
    };
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c060f7a5f9ff83a55833.js